import { WordObject } from "../../interfaces/word-object/WordObject";
import {Word} from "./Word";

 export class Noun extends Word {
    public artikel;
    public plural;
    public meaning: any;
//    public translation;
    constructor(word: WordObject){
        super(word);
        this.artikel = word.artikel;
//        this.perfect = word.perfect;
        this.plural = word.plural;
    }
    hasArtikel(): boolean {
        return true;
    }
}